import styled from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import type { ProgressBarVariant } from "./ProgressBar.model";

interface ProgressBarContainerProps extends ThemeProps {}

interface ProgressBarActiveSegmentProps extends ThemeProps {
  $variant: ProgressBarVariant;
  $width: number;
}

export const StyledProgressBar = styled.div<ProgressBarContainerProps>`
  height: 0.5rem;
  width: 100%;
  border-radius: 1rem;
  background-color:  ${({ theme }: ProgressBarContainerProps) => theme.palette.neutral._900};
`;

export const StyledProgressBarActiveSegment = styled.div<ProgressBarActiveSegmentProps>`
  height: 100%;
  width: ${({ $width }: ProgressBarActiveSegmentProps) => $width || 0}%;

  border-radius: 1rem;
  background-color: ${({ theme, $variant }: ProgressBarActiveSegmentProps) => {
    switch ($variant) {
      case "primary":
        return theme.palette.primary.brand;
      case "success":
        return theme.palette.feedback.success._800;
      case "warning":
        return theme.palette.yellow._800;
      case "error":
        return theme.palette.feedback.error.brand;
      default:
        return theme.palette.secondary.brand;
    }
  }};
`;
